<template>
  <div class="container">
    <content-template>
      <template slot="left">{{postTitle}}</template>
      <template slot="right">
      </template>
      <template slot="banner">
        <img v-if="thumbnail" :src="thumbnail" class="top-banner" alt="">
        <img v-else src="@/assets/thumbnail.png" class="top-banner" alt="">
      </template>
      <template slot="content">
      <div v-html="pageContent" class="article-content"></div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      pageContent: '',
      thumbnail: '',
      postTitle: '',
      intro: true,
      general: false
    }
  },
  methods: {
    getPage: function (page) {
      var that = this
      var url = this.$url + 'portal/pages/' + page
      this.$axios.get(url)
        .then(function (response) {
          // console.log(response.data.data)
          if (response.data.code === 1) {
            that.pageContent = response.data.data.post_content
            that.thumbnail = response.data.data.more.thumbnail
            that.postTitle = response.data.data.post_title
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 关于本站
    getIntroduct: function () {
      this.getPage(1)
    }
  },
  created () {
    this.getIntroduct()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/introduct/introduct.vue